import { render, staticRenderFns } from "./TDeleteDropdownItem.vue?vue&type=template&id=4982d52c&"
import script from "./TDeleteDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./TDeleteDropdownItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports